const BASE_TENANTS = `/ui/v1/tenants`;
import { clearActiveApiOrigin } from "src/utils/activeApiEndpoint";
import { getSessionAbortController } from "src/utils/session";

export const Tenants = {
  /**
   * Switches the tenant.
   *
   * @param tenantId - unique id assigned to a tenant
   * @param startUrl - redirect path after success
   */
  switchTenant: (tenantId: string, startUrl: string) => {
    /*
     * When switching tenants we need to ignore any requests
     * that fail with 401 while the page is redirecting.
     * Aborting the session controller removes all listeners
     * registered with its signal, preventing false logout triggers
     * during the tenant switch redirect.
     */
    getSessionAbortController().abort();

    clearActiveApiOrigin();

    /**
     * Dynamically create a form submission to navigate browser
     * to a redirect endpoint instead of fetching to avoid CORS error.
     */
    const form = document.createElement("form");
    form.method = "POST";
    form.action = `${BASE_TENANTS}/${tenantId}/sessions`;

    const input = document.createElement("input");
    input.type = "hidden";
    input.name = "startUrl";
    input.value = `${window.location.origin}${startUrl}`;

    form.appendChild(input);
    form.style.display = "none";
    document.body.appendChild(form);
    form.submit();
  }
};
